module.exports = __webpack_public_path__ + "../resources/img/bg_grid2_01.bf4e0f7f.png";